module.exports = __webpack_public_path__ + "static/truck-landscape-47c8d2ae7335f3805352def8f3956fb2.svg";